module.exports = __webpack_public_path__ + "static/img/雅生真我系列特殊材质面板AXORSignaturePlates.b9e9ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/雅生真我系列特殊材质面板AXORSignaturePlates.jpg
// module id = UpUT
// module chunks = 1